import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, LOGOUTVIEWLABELS } from '../_constants/constants';
import { LoaderService } from '../_services/loader.service';
import { SessionTimeoutService } from '../_services/sessionTimeout.service';
export interface LogoutModel {
  
}

@Component({
    templateUrl: 'logout.dialog.component.html'
})

export class LogoutDialogComponent extends DialogComponent<LogoutModel, string> {
  
    logoutviewlabels = LOGOUTVIEWLABELS;

	constructor(private http: Http, private ds: DialogService, private loaderService: LoaderService,private sessionTimeoutService:SessionTimeoutService) {
		  super(ds);
    }

    agentLogoutRequest() { 

		this.close();  
		this.sessionTimeoutService.logoutSession(); 	
    // 	this.loaderService.display(true);
    // 	localStorage.setItem('searchData',JSON.stringify({}));
    // 	localStorage.setItem('language',"");
    // 	localStorage.setItem('opco-header',"");
    // 	localStorage.setItem('opco',"");
    // 	localStorage.setItem('country',"");
    // 	localStorage.setItem('localized',"");

	//     const URL = (environment.BASE_URL_BACKEND + APIURLS.AGENT_Operations_Logout);
	//     const headers = new Headers();

	//     const options = new RequestOptions({ headers: headers, withCredentials: true });
	//     // ATTENTION: Backend has to invalidate the session and in the positive case a redirect to first page will end in a fail in the filter
	//     this.http.post(URL, options).subscribe(
	//       response => {	      	
	//         window.location.href = '/';	        
	//       },
	//       error => {	      	
	//         window.location.href = '/';	        
	//       }
	//    );
 	}
}



// WEBPACK FOOTER //
// ./src/app/logout/logout.dialog.component.ts